import React from "react";
import { useNavigate } from "react-router-dom";
import { UserCircle2, Layers } from "lucide-react";
import { StatCard } from "./components/cards";
import { useWarehouseMetrics } from "./warehouse-metrics-api";

// "Data Hub Performance" — real GET /api/v1/dashboard/warehouse-metrics
// (overview group) now that it exists. "Connected" and "Current Activations"
// used to be duplicated here with different hardcoded numbers than the same
// counts already shown in "Connect Your Data Ecosystem" and the channel
// grids below (0 vs 2, 0 vs 12) — removed rather than reconciled, since
// those two sections already cover that ground with real data.
export const PerformanceMetricsSection: React.FC = () => {
  const navigate = useNavigate();
  const { loading, findMetric, formatValue } = useWarehouseMetrics();
  const unifiedProfiles = findMetric("overview", ["unified_profiles", "total_visitors"], ["Unified Profiles", "Total Visitors"]);
  const matchRate = findMetric("overview", ["match_rate"], ["Match Rate"]);

  return (
    <section>
      <h2 className="text-base sm:text-lg font-semibold text-gray-900 dark:text-gray-100">Data Hub Performance</h2>
      <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5 mb-3">
        Track how effectively your customer data is being unified, matched, and activated across ConvoHub.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <StatCard
          icon={<UserCircle2 size={16} />}
          iconClassName="bg-indigo-50 dark:bg-indigo-500/15 text-indigo-600 dark:text-indigo-400"
          label="Unified Profiles"
          value={formatValue(unifiedProfiles)}
          description="Customer records combined into a single unified profile."
          linkLabel="Unify Profiles"
          onLinkClick={() => navigate("/unify/dashboard")}
          loading={loading}
          isSample={unifiedProfiles?.is_sample}
        />
        <StatCard
          icon={<Layers size={16} />}
          iconClassName="bg-purple-50 dark:bg-purple-500/15 text-purple-600 dark:text-purple-400"
          label="Match Rate"
          value={formatValue(matchRate)}
          description="Percentage of incoming records successfully matched to existing profiles."
          loading={loading}
          isSample={matchRate?.is_sample}
        />
      </div>
    </section>
  );
};

export default PerformanceMetricsSection;
